import { render, staticRenderFns } from "./TotalMentalHealthStart.vue?vue&type=template&id=35173b2a"
import script from "./TotalMentalHealthStart.vue?vue&type=script&lang=js"
export * from "./TotalMentalHealthStart.vue?vue&type=script&lang=js"
import style0 from "./TotalMentalHealthStart.vue?vue&type=style&index=0&id=35173b2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports